import { formatDate } from '@jebel/utils';

export const getMessageTimeStamp = (date: any) => formatDate(date, 'MMM dd - t');
